export const SOURCE_NAMES = {
  'EI3': 'Encyclopaedia of Islam THREE',
  'EI2': 'Encyclopaedia of Islam Second Edition',
  'EIr': 'Encyclopaedia Iranica',
  'EIs': 'Encyclopedia Islamica',
  'DMBI': 'Dānešnāma-ye Bozorg-e Eslāmī',
  'DİA': 'Türkiye Diyanet Vakfı İslâm Ansiklopedisi'
};

export const TABAQAT_SOURCES = [
  { key: 'hilya', label: 'Hilya' },
  { key: 'sulami', label: 'Sulami' },
  { key: 'ansari', label: 'Ansari' },
  { key: 'manaqib', label: 'Manaqib' },
  { key: 'attar', label: 'Attar' },
  { key: 'jami', label: 'Jami' }
];

export const ITEMS_PER_PAGE = 20;